module.exports = __webpack_public_path__ + "img/rouler_positions_3.6ef73d27.png";